import React from 'react';

import { expValEquals } from '@confluence/feature-experiments';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';

import { isExpectedAutohighlightsError } from './isExpectedAutohighlightsError.ts';

type AutohighlightsErrorDisplayProps = {
	error: Error;
};

export const AutohighlightsErrorDisplay = ({
	error,
}: AutohighlightsErrorDisplayProps): React.JSX.Element | null => {
	if (!expValEquals('cc-reduce-js-error-rate-batch1', 'isEnabled', true)) {
		return null;
	}

	if (isExpectedAutohighlightsError(error)) {
		markErrorAsHandled(error);
		return null;
	}

	return <ErrorDisplay error={error} />;
};
